import { useState } from "react";
import { toast } from "sonner";
import { apiError, scaricaFile } from "@/lib/api";

/** Pulsante che scarica un file dall'API via fetch (niente popup): mostra stato e errori. */
export function BottoneScarica({ path, nomeFallback, className, children, title, testid }) {
  const [inCorso, setInCorso] = useState(false);
  const avvia = async () => {
    setInCorso(true);
    try {
      await scaricaFile(path, nomeFallback);
      toast.success("Download avviato");
    } catch (e) {
      toast.error(`Download non riuscito: ${apiError(e)}`);
    } finally {
      setInCorso(false);
    }
  };
  return (
    <button type="button" onClick={avvia} disabled={inCorso} title={title} data-testid={testid}
      className={`${className} disabled:opacity-60`}>
      {inCorso ? "Preparazione…" : children}
    </button>
  );
}
